import * as React from 'react';
import { Link, MemoryRouter, Route, Routes, useLocation } from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import {Fragment} from "react";
const Pagination_bk = (props) => {


    return (
        <>

            {

                props.count_pages > 1 ?  (

                    <Fragment>
                        <Pagination  className={props.class_nav_pagination_bk}
                                     page={parseInt(props.page_active)}
                                     count={props.count_pages}
                                     renderItem={(item) => (
                                         <PaginationItem className={props.class_item_pagination_bk}
                                                         component={Link}
                                                         reloadDocument={true} /////ddddddddddddddddddddddd
                                                         to={`/${item.page === 1 ? props.link_page_curent :  props.link_page_curent + `?page=${item.page}`}`}
                                                         rel
                                                         {...item}
                                         />
                                     )}
                        />
                    </Fragment>

                ) : (
                    <Fragment></Fragment>
            )

            }


        </>

    );
}





export default  Pagination_bk;